import {useEffect, useState} from "react";
import {makeApolloClientCall} from "../api/makeApolloApiCall.js";
import {CURRENT_PERIOD_QUERY} from "./periods.js";

/**
 * Period object representing a financial or business period.
 * @typedef {Object} Period
 * @property {number} periodYear - The year of the period (e.g., 2025)
 * @property {string} spinsPeriod - The formatted period identifier combining year and period number (e.g., "2025_P11")
 * @property {number} periodNumber - The sequential number of the period within the year (e.g., 11)
 * @property {string} periodEndDate - The end date of the period in ISO format (YYYY-MM-DD)
 * @property {string} periodAbbreviation - A short identifier for the period (e.g., "2025-P11")
 */
/**
 * Custom hook to fetch and manage the current period data.
 * It initializes the period state, fetches data using the specified query,
 * and updates the period state accordingly.
 *
 * @return {Period} The current period data.
 */
export function useCurrentPeriod() {
    const [period, setPeriod] = useState({
        periodYear: 0,
        spinsPeriod: "",
        periodNumber: 0,
        periodEndDate: "",
        periodAbbreviation: ""
    })

    useEffect(() => {
        makeApolloClientCall(CURRENT_PERIOD_QUERY, false, {}).then(({data}) => setPeriod(data))
    }, [])

    return period
}